import { computed, Injectable, signal } from '@angular/core';
import { IActivityHistoryFilterState } from '@dxp/core/models';
import { ChannelGroupType } from '@dxp/core/types';
import { ViewType } from '@dxp/core/helpers';

const LEFT_SPLIT_PANEL = 0;
const RIGHT_SPLIT_PANEL = 1;

@Injectable({
    providedIn: 'root',
})
export class SettingsService {
    readonly #panels = signal<number[]>([0, 0]);
    readonly viewType = signal<ViewType>('standard');
    readonly channelGroupFilter = signal<ChannelGroupType | undefined>(
        undefined,
    );

    readonly chatFooterHeight = signal<number>(0);

    set leftPanelSize(size: number) {
        this.#panels.update(panel => [size, panel[RIGHT_SPLIT_PANEL]]);
    }

    set rightPanelSize(size: number) {
        this.#panels.update(panel => [panel[LEFT_SPLIT_PANEL], size]);
    }

    leftPanel = computed<number>(() => this.#panels()[LEFT_SPLIT_PANEL]);
    rightPanel = computed<number>(() => this.#panels()[RIGHT_SPLIT_PANEL]);

    agentActivityHistoryState = signal<IActivityHistoryFilterState>({
        queueOrAgentSelection: [],
        channelSelection: [],
        channelTypesSelection: [''],
        directionSelection: 'All',
        sortSelection: 'newest',
        completionCodeSelection: [],
        subjectId: '',
        typeId: undefined,
        dateFrom: new Date(),
        dateTo: new Date(),
    });

    customerActivityHistoryState = signal<IActivityHistoryFilterState>({
        queueOrAgentSelection: [],
        channelSelection: [],
        channelTypesSelection: [''],
        directionSelection: 'All',
        sortSelection: 'newest',
        completionCodeSelection: [],
        subjectId: '',
        typeId: undefined,
        dateFrom: new Date(),
        dateTo: new Date(),
    });
}
